// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oiHM+","error":"styles_error__D5P6a"};